<template>
  <div id="main">
    <div id="navdiv">
      <ul id="nav">
        <li @click="switchView('all')">Get all</li>
        <li v-for="e in types" :key="e" @click="switchView(e)">Get by {{ e }}</li>
      </ul>
    </div>
    <h2>Get {{ displayActive }}</h2>
    <div id="input" v-if="active !== 'all'">
      <label>Input {{ active }} to use as a filter:</label>
      <input v-model.trim="input">
    </div>
    <div id="result">
      <p v-if="active === 'all'" class="result">{{ getAll }}</p>
      <p v-else-if="active === 'id'" class="idResult">{{ getById(input) }}</p>
      <ul v-else class="result">
        <li v-for="elem in returnOutput" :key="elem.id" class="result">{{ elem }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      active: 'all',
      types: ['id', 'rism_id', 'title', 'composer', 'librettist', 'year', 'city', 'country'],
      input: ''
    };
  },

  computed: {
    ...mapGetters(['getAll', 'getById', 'getByOperaId', 'getByTitle', 'getByComposer', 'getByLibrettist', 'getByYear', 'getByCity', 'getByCountry']),
    displayActive() {
      if (this.active !== 'all') {
        return 'by ' + this.active;
      } else return 'all';
    },
    returnOutput() {
      switch (this.active) {
        case 'id':
          return this.getById(this.input);
        case 'rism_id':
          return this.getByOperaId(this.input);
        case 'title':
          return this.getByTitle(this.input);
        case 'composer':
          return this.getByComposer(this.input);
        case 'librettist':
          return this.getByLibrettist(this.input);
        case 'year':
          return this.getByYear(this.input);
        case 'city':
          return this.getByCity(this.input);
        case 'country':
          return this.getByCountry(this.input);
        default:
          return [];
      }
    }
  },

  methods: {
    switchView(type) {
      this.active = type;
    },
  },
}
</script>

<style scoped>
div#main {
  text-align: center;
}

ul#nav {
  margin-left: 10%;
  margin-right: 10%;
  border: #000000 1px solid;
  border-radius: 1rem;
  background-color: #80ffd4;
  list-style-type: none;
  vertical-align: middle;
  padding: 0;
}

ul#nav li {
  display: inline;
  display: inline-block;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin: 0.5rem;
  padding: 0.8rem;
  background-color: #adffe4;
  border: #2b8d45 2px solid;
  border-radius: 1rem;
}

ul#nav li:first-child {
  margin-top: 1rem;
}

ul#nav li:last-child {
  margin-bottom: 1rem;
}

ul#nav li:hover {
  background-color: #85c5b0;
  cursor: pointer;
}

h2 {
  margin-top: 3rem;
}

div#input {
  border: #000 1px solid;
  border-radius: 1rem;
  padding: 0.5rem;
  width: 600px;
  margin: auto;
}

label,
input {
  margin: 0.5rem;
  padding: 0.5rem;
  min-width: 15rem;
}

p.result {
  width: 80%;
  margin: auto;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

p.idResult {
  width: 20%;
  margin: auto;
  padding: 0.7rem;
  border: #000 1px solid;
  border-radius: 1rem;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

ul.result {
  list-style-type: none;
  padding: 0;
  width: 90%;
  margin: auto;
  margin-top: 3rem;
  margin-bottom: 2rem;
}

li.result {
  display: inline;
  display: inline-block;
  width: 16%;
  padding: 0.7rem;
  margin: 0.8rem;
  border: #000 1px solid;
  border-radius: 1rem;
}
</style>
